//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import { scroll } from 'quasar';
const { getScrollTarget, setScrollPosition } = scroll;
import { i18n } from '@/i18n';
import firebase from 'firebase/app'
import 'firebase/firestore';
// import axios from 'axios';
export default {
    name:'app-articles',
    props:['slicedArticles'],
    data(){
        return{
            article:false,
            articles:[],
            cachedArticles:[],
            cachedRows:[],
            cachedArticlesSize:'',
            // msg:"hellooo"
        }
    },
//     metaInfo() {
//     return {
//       title: "test meta data with vue",
//       meta: [
//         {
//           vmid: "description",
//           name: "description",
//           content:
//             "hello world, this is an example of adding a description with vueMeta"
//         }
//       ]
//     };
//   },
    computed:{
        skeletonLength(){
            if(this.$router.currentRoute.path == "/"){
                return 3
            }
            else{
                return 15
            }
        },
         ...mapGetters({
            rows: 'article/list/rows',
            count: 'article/list/count',
            loading: 'article/list/loading',
         })
     },
    methods:{
         i18n(key, args) {
      return i18n(key, args);
    },
        showArticle(article){
            // const title= article.title.replace(/ /g,"_");
            // const id = article.id
            // console.log("id",id)
            this.$router.push({ 
                // path: `/article/${title}/${id}`, query: { 
                path: `/article/${article.uri}`,
                // query: { 
                // id: article.uri,
                // image: article.image
                
                // },
                })

        },
        ...mapActions({
             navigation: 'layout/navigation',
           
            doFetch: 'article/list/doFetch',
    
    }),


    },
    async created(){
        setTimeout(async () => {

        
    await firebase.firestore().collection('article').onSnapshot({ includeMetadataChanges: true },async () => {
      const articles = await firebase.firestore().collection("article").get({source: 'cache'})
      this.cachedArticlesSize = articles.size
      this.cachedRows = []
      articles.forEach(doc => {
        this.cachedRows.push(doc.data())
      })
    //   firebase.database().ref('article').child(gettersDate).set(true)
      for(let article of this.cachedRows){
            article.title = article && article.title ? article.title.slice(0,170):''
            article.body = article.body.slice(0, 50)
            if(article.date.seconds){
                article.date = new Date(article.date.seconds*1000)
            }
            if(article.date.milliseconds){
                article.date = new Date(article.date.milliseconds*1000000)
            }
            else{
            article.date = new Date(article.date)
            }
            article.date = article.date.toString().slice(0,21)
        }
        this.cachedArticles = this.cachedRows 
        if(this.$router.currentRoute.path == "/"){
            this.cachedArticles =  this.cachedRows.slice(0,3)
        }        
        })
            },3000)
         if(this.$router.currentRoute.path !== "/"){
            this.navigation('news')
            if(document.getElementById('articles')){
               const ele = document.getElementById('articles');
            const target = getScrollTarget(ele);
            const offset = ele.offsetTop-120;
            const duration = 0;
            setScrollPosition(target, offset, duration); 
            }
            
         }
            

    }

}
